import React, { useEffect, useState } from 'react';
import { bookMarkCourse, downloadCertificate, userEnrolledCourse } from '../../api/apiHandler';
import { Link, useLocation } from 'react-router-dom';
import { encryption } from '../../common/enc_dec';
import { showPromiseNotification } from '../../common/notification';
import { Loading } from '../../components/loading/loading';
import { formatDuration } from '../../common/utilityFunctions';
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';
import '../../i18';

const Course = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const isCompleted = location.state?.tab;
    const [activeTab, setActiveTab] = useState(isCompleted ? "completed" : "progress");
    const [course, setCourse] = useState([]);
    const [certificate, setCertificate] = useState([]);
    const [pageToken, setPageToken] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (!hasMounted) setIsLoading(true);
            try {
                await getUserCourse();
            } catch (error) {
                console.error('Failed to fetch test data:', error);
            } finally {
                if (!hasMounted) setIsLoading(false);
                setHasMounted(true);
            }
        };

        fetchData();
    }, [activeTab, pageToken]);

    const getUserCourse = async () => {
        const params = {
            is_random_test: false,
            is_test_completed: activeTab === 'completed',
            page: pageToken,
            limit: 6
        };

        const response = await userEnrolledCourse(params);

        if (response?.code === 200) {
            setCourse(response?.data?.data);
            setTotalPage(response.data.paging);
        }
        else {
            setCourse([]);
            setTotalPage('');
        }
    };

    const handleBookmark = async (courseId) => {
        const myPromise = new Promise(async (resolve, reject) => {
            const response = await bookMarkCourse({ course_id: courseId });
            if (response?.code === 200) {
                getUserCourse();
                resolve(response);
            } else {
                reject(response);
            }
        });
        showPromiseNotification(myPromise);
    };

    const handleDownloadCertificate = async (courseId) => {
        const certificateResponse = await downloadCertificate({
            course_id: courseId
        })

        if (certificateResponse.code === 200) {
            setCertificate(certificateResponse?.data);
            window.open(certificateResponse?.data?.certificate, '_blank');
        }
    }

    const handlePageClick = (e) => {
        setPageToken(e.selected + 1)
    }

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox pb-0">
                                <h2 className="PageTitleHeading">{t('courseHeading')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="edmt-nav-tab style-white text-start">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${activeTab === 'progress' ? 'active' : ''}`}
                                            id="tab1-tab"
                                            data-toggle="tab"
                                            href="#tab1"
                                            role="tab"
                                            aria-controls="tab1"
                                            aria-selected={activeTab === 'progress'}
                                            onClick={() => {
                                                setActiveTab('progress')
                                                setPageToken(1)
                                            }}
                                        >
                                            {t('onProgress')}
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${activeTab === 'completed' ? 'active' : ''}`}
                                            id="tab2-tab"
                                            data-toggle="tab"
                                            href="#tab2"
                                            role="tab"
                                            aria-controls="tab2"
                                            aria-selected={activeTab === 'completed'}
                                            onClick={() => {
                                                setActiveTab('completed')
                                                setPageToken(1)
                                            }}
                                        >
                                            {t('completed')}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {activeTab === 'progress' && course.length === 0 && (
                            <h4 className='text-center mt-3 fw-light'>{t('emptyCourseList')}</h4>
                        )}
                        {activeTab === 'completed' && course.length === 0 && (
                            <h4 className='text-center mt-3 fw-light'>{t('noCompletedCourses')}</h4>
                        )}
                        {course.length > 0 && (
                            <div className="col-12">
                                <div className="tab-content" id="myTabContent">
                                    <div
                                        className="tab-pane fade show active"
                                        id={activeTab}
                                        role="tabpanel"
                                        aria-labelledby={`${activeTab}-tab`}
                                    >
                                        <div className="row">
                                            {course.map(course => (
                                                <div className="col-lg-4 col-md-6 CourseGride" key={course.id}>
                                                    <div className="single-course-inner">
                                                        {activeTab !== 'completed' && !course.is_expired ? (
                                                            <>
                                                                <Link
                                                                    to={`/start-course/${encodeURIComponent(encryption({
                                                                        course_id: course.course_id,
                                                                        category_id: course.user_course.category_id,
                                                                        language: course.user_course.language,
                                                                        is_completed: course.is_completed
                                                                    }, true))}`}
                                                                    className="thumb"
                                                                >
                                                                    <img src={course?.user_course?.image} alt="course" />
                                                                </Link>
                                                            </>
                                                        ) : (
                                                            <div className="thumb" style={{ position: "relative" }}>
                                                                <img src={course?.user_course?.image} alt="course" />
                                                                {course.is_expired && (
                                                                    <span className='expire-course'>{t('expired')}</span>
                                                                )}
                                                            </div>
                                                        )}
                                                        <div className="details">
                                                            {activeTab !== 'completed' && !course.is_expired ? (
                                                                <Link to={`/start-course/${encodeURIComponent(encryption({
                                                                    course_id: course.course_id, category_id: course.user_course.category_id, language: course.user_course.language,
                                                                    is_completed: course.is_completed
                                                                }, true))}`} className="details-inner">
                                                                    <div className="d-flex justify-content-between mb-3">
                                                                        <p className="CardMainHeading">{course.user_course?.course_category?.name}</p>
                                                                        {course?.user_course?.assign_trainer[0] ? (
                                                                            <div className="emt-user">
                                                                                <span className="u-thumb">
                                                                                    <img src={course?.user_course?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="author" />
                                                                                </span>
                                                                                <span className="align-self-center">{course?.user_course?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="emt-user"></div>
                                                                        )}
                                                                    </div>
                                                                    <h6 className="CardMainSubHeading text-truncate-2">
                                                                        {course.user_course?.name}
                                                                    </h6>
                                                                    <div className="LassonsMain">
                                                                        <ul className="LassonsUl">
                                                                            <li className="LassonsLi">
                                                                                <p className="Lessonstext">{course.user_course.total_lession} {t('lessons')}</p>
                                                                            </li>
                                                                            <li className="dots" />
                                                                            <li className="LassonsLi">
                                                                                <p className="Lessonstext">{formatDuration(course?.user_course.duration, t)}</p>
                                                                            </li>
                                                                            <li className="dots" />
                                                                            <li className="LassonsLi">
                                                                                <p className="Lessonstext">
                                                                                    <strong>{course.user_course.validity} </strong>{t('daysValidity')}
                                                                                </p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </Link>
                                                            ) : (
                                                                <div className="details-inner">
                                                                    <div className="d-flex justify-content-between mb-3">
                                                                        <p className="CardMainHeading">{course.user_course?.course_category?.name}</p>
                                                                        {course?.user_course?.assign_trainer[0] ? (
                                                                            <div className="emt-user">
                                                                                <span className="u-thumb">
                                                                                    <img src={course?.user_course?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="author" />
                                                                                </span>
                                                                                <span className="align-self-center">{course?.user_course?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="emt-user"></div>
                                                                        )}
                                                                    </div>
                                                                    <h6 className="CardMainSubHeading text-truncate-2">
                                                                        {course.user_course?.name}
                                                                    </h6>
                                                                    <div className="LassonsMain">
                                                                        <ul className="LassonsUl">
                                                                            <li className="LassonsLi">
                                                                                <p className="Lessonstext">{course.user_course.total_lession} {t('lessons')}</p>
                                                                            </li>
                                                                            <li className="dots" />
                                                                            <li className="LassonsLi">
                                                                                <p className="Lessonstext">{formatDuration(course?.user_course.duration, t)}</p>
                                                                            </li>
                                                                            <li className="dots" />
                                                                            <li className="LassonsLi">
                                                                                <p className="Lessonstext">
                                                                                    <strong>{course.user_course.validity} </strong>{t('daysValidity')}
                                                                                </p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div className="emt-course-meta">
                                                                <div className="LassonsCardFooter">
                                                                    <ul className="LassonsCardFooterUl">
                                                                        <li className="LassonsCardFooterLi">
                                                                            <div className="rating">
                                                                                <i className="fa fa-star" /> {course.user_course.avg_review}
                                                                                <span>({course.user_course.total_review})</span>
                                                                            </div>
                                                                        </li>
                                                                        <li className="LassonsCardFooterLi">
                                                                            <div className="price">
                                                                                <span>₹{course.user_course.price}</span>
                                                                            </div>
                                                                        </li>
                                                                        <li className="LassonsCardFooterLi">
                                                                            {activeTab === 'completed' ? (
                                                                                    course?.certificate != null && course?.certificate != undefined && (
                                                                                        <button className="StarttestLink" onClick={() => handleDownloadCertificate(course?.course_id)}>
                                                                                            {t('certificate')}
                                                                                            <img
                                                                                                src={process.env.PUBLIC_URL + "/assets/img/icon/downloadCertificateicon.svg"}
                                                                                                alt="downloadCertificateicon"
                                                                                                className="downloadCertificateicon"
                                                                                            />
                                                                                        </button>
                                                                                    )
                                                                            ) : (
                                                                                <div className="price" onClick={() => handleBookmark(course?.course_id)} style={{ cursor: "pointer" }}>
                                                                                    {course?.user_course?.is_favorite ? (
                                                                                        <i className="fa-solid fa-bookmark" />
                                                                                    ) : (
                                                                                        <i className="fa-regular fa-bookmark" />
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {course && course.length > 0 && (
                            <ReactPaginate
                                className='pagination mt-4'
                                breakLabel="..."
                                nextLabel={`${t('next')} >`}
                                previousLabel={`< ${t('Previous')} `}
                                renderOnZeroPageCount={null}
                                onPageChange={handlePageClick}
                                pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                                forcePage={pageToken - 1}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Course;